import React, { useMemo } from 'react'
import { useLoad } from '../../../../../../shared/hooks/load'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Menu, MenuAdd } from '../../../../../../shared/menu/menu'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useApiFormLoginUser, useApiListLoginUser } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconOrganization } from '../../../../../../shared/icon/icon'
import { useRoleSysLogin } from '../../../../../../role/hook/role-sys'
import { ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { OrganizationGrid } from '../../../../../../shared/org-search/organization-grid'

// Add a login to an organization: every organization, server-paged and
// searchable (owner 2026-10-13: never the whole list); one the login is
// already in offers no add.
export function OrganizationUserAdd() {
  const { loginID } = useParamsInt()

  const apiListLoginUser = useApiListLoginUser()
  const apiFormLoginUser = useApiFormLoginUser()

  useLoad(() => apiListLoginUser.get(`${loginID}/login`), [loginID])

  const handleCreate = async item => {
    await apiFormLoginUser.post({ organizationID: item.id, loginID: loginID })
    await apiListLoginUser.get(`${loginID}/login`)
  }

  const roleSysLogin = useRoleSysLogin()

  const memberOf = useMemo(() => new Set((apiListLoginUser.items || []).map(i => Number(i.organizationID))), [apiListLoginUser.items])

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconOrganization} text="Add login to organization">
        <CardFullHeightScrollY title="add login to organization">
          <OrganizationGrid>
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuAdd text="add" onClick={() => handleCreate(row)} show={roleSysLogin.accessCreate && !memberOf.has(Number(row.id))} />
                </Menu>}
            />
          </OrganizationGrid>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
